import styles from './index.scss'
import React, { useRef, useState, useEffect } from 'react'
import { ActionSheet, SpinLoading } from 'antd-mobile'
import { memberInfo } from '@/services/index'
import goTo from '@/libs/functions/goTo'
import Layout from '@/libs/components/Layout'
import { orderStatusList, OrderStatusType } from '@/libs/globalData'
import { tenantStyles } from '@/services'
import { getStorage } from '@/libs/functions/onStorage'

type InfoDataType = {
  mobile: string
  userCode: string
  nickName: string
  userPoint: number
}

export default function PersonalCenter() {
  const [infoData, setInfoData] = useState<InfoDataType>({
    mobile: '',
    userCode: '',
    nickName: '',
    userPoint: 0,
  })
  const [loading, setLoading] = useState(true)
  const [visiblePhone, setVisiblePhone] = useState(false)
  const [styleConfig, setStyleConfig] = useState<any>({
    page: {
      pageTitle: '个人中心',
      appellation: '尊敬的私人银行客户',
      backgroundType: 'image',
      backgroundColor: '#f34242',
      backgroundImage:
        'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-04-23_183749/img_personal_bg.png',
      avatarShow: true,
      nameShow: true,
      phoneShow: true,
      backHomeShow: false,
      backHomeIcon:
        'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-04-24_095030/back-ico.png',
      backHomeUrl: '/index',
    },
    point: {
      backgroundType: 'color',
      backgroundColor: '#f34242',
      backgroundImage:
        'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-04-25_153328/point_icon.png',
      show: false,
      showStyle: 1,
    },
    enter: [
      {
        text: '服务订单',
        show: true,
        icon: '',
        desc: '服务订单',
        url: '/order/orderRecord?status=',
      },
      {
        text: '实物订单',
        show: false,
        icon: '',
        desc: '实物订单',
        url: '/order/physicalGoodsOrderRecord?status=',
      },
      {
        text: '权益列表',
        show: true,
        icon: '',
        desc: '权益列表',
        url: '/equity/equityList',
      },
      {
        text: '优惠券',
        show: true,
        icon: '',
        desc: '优惠券',
        url: '/discountCouponList',
      },
      {
        text: '兑换码',
        show: true,
        icon: '',
        desc: '兑换码',
        url: '/equity/codeExchange',
      },
      {
        text: '权益绑定',
        show: true,
        icon: '',
        desc: '权益绑定',
        url: '/equity/exchange',
      },
      {
        text: '联系客服',
        show: true,
        icon: '',
        desc: '联系客服',
        url: 'service',
      },
    ],
  })
  const { enter, page, point } = styleConfig

  const personalPageStyle =
    page.backgroundType === 'color'
      ? {
          backgroundImage: `linear-gradient(to bottom, ${page.backgroundColor} 0, ${page.backgroundColor} 192px, #f5f6f8 192px, #f5f6f8 100%)`,
        }
      : {
          background: `url(${page.backgroundImage})  0% 0% / 100% no-repeat`,
          backgroundSize: '100% auto',
        }
  const pointBackgroundStyle =
    point.backgroundType === 'color'
      ? {
          background: point.backgroundColor,
        }
      : {
          background: `url(${point.backgroundImage})  0% 0% / 100% no-repeat`,
          backgroundSize: '100% auto',
        }
  useEffect(() => {
    setLoading(true)
    // 识别到是代客经理，需要跳转到代客经理 代下单服务页
    const isBackDkHomePage = getStorage('isBackDkHomePage') || ''
    if (isBackDkHomePage) {
      goTo('/dk/customers')
      setTimeout(() => {
        setLoading(false)
      })
      return
    }
    tenantStyles({ types: ['personal'] })
      .then((res: any) => {
        const { personal } = res
        personal && setStyleConfig(personal)
      })
      .finally(() => setLoading(false))
    memberInfo().then((res: any) => {
      setInfoData(res)
    })
  }, [])
  return loading ? (
    <div className={styles.loadingBox}>
      <SpinLoading style={{ margin: '0 auto' }} />
    </div>
  ) : (
    <Layout
      title={page.pageTitle}
      backArrow={page.backHomeShow}
      backIcon={page.backHomeIcon}
      onBack={() => {
        goTo(page.backHomeUrl)
      }}
    >
      <div className={styles.personalPage} style={personalPageStyle}>
        <div className={styles.info}>
          {page.avatarShow && (
            <img
              src={require('@/assets/image/personalCenter/img_portrait.png')}
              className={styles.avatar}
            />
          )}
          <div className={styles.right}>
            <div className={styles.centre}>
              <div className={styles.greeting}>{page.appellation}</div>
              {page.phoneShow && (
                <div className={styles.phone}>{infoData.mobile}</div>
              )}
            </div>
            {page.nameShow && (
              <div className={styles.name}>{infoData.nickName}</div>
            )}
          </div>
        </div>
        {point.show && (
          <div className={styles.myPoint} style={pointBackgroundStyle}>
            <div className={styles.left}>
              <img
                className={styles.pointIcon}
                src={require('@/assets/image/personalCenter/point_icon.png')}
              />
              <div className={styles.text}>积点</div>
              <div className={styles.count}>{infoData.userPoint}</div>
            </div>
            <div
              className={styles.right}
              onClick={() => goTo('/personalCenter/myPoint')}
            >
              <div className={styles.value}>查看记录</div>
              <img
                className={styles.arrows}
                src={require('@/assets/image/ico_enter.png')}
              />
            </div>
          </div>
        )}
        <div className={styles.cellGroup}>
          {enter
            .filter((item: any) => item.show)
            .map((item: any, index: number) => (
              <a
                className={styles.cell}
                key={index}
                onClick={() => {
                  if (item.url === 'service') {
                    setVisiblePhone(true)
                    return
                  }
                  goTo(
                    item.url?.indexOf('?') >= 0
                      ? `${item.url}&title=${item.desc || ''}`
                      : `${item.url}?title=${item.desc || ''}`,
                  )
                }}
              >
                <div className={styles.left}>
                  {item.icon && <img className={styles.icon} src={item.icon} />}
                  <div className={styles.title}>{item.desc}</div>
                </div>
                <div className={styles.right}>
                  {/* <div className={styles.value}>400-882-1111</div> */}
                  <img
                    className={styles.arrows}
                    src={require('@/assets/image/personalCenter/ico_enter.png')}
                  />
                </div>
              </a>
            ))}
        </div>
        <ActionSheet
          extra="联系客服"
          visible={visiblePhone}
          actions={[
            {
              text: '400-882-1111',
              key: 'phone',
              onClick: () => {
                window.location.href = 'tel://400-882-1111'
              },
            },
          ]}
          onClose={() => setVisiblePhone(false)}
        />
      </div>
    </Layout>
  )
}
